import Icon from '../components/Icon';

const Running = Icon(
  'running',
  <>
    <path
      fillRule="evenodd"
      d="M16.5 6.69a2.7 2.7 0 0 1-1.12-.23 2.8 2.8 0 0 1-1.45-1.53 2.73 2.73 0 0 1 .07-2.1 2.75 2.75 0 0 1 3.63-1.4 2.75 2.75 0 0 1-1.13 5.26m0-4a1.2 1.2 0 0 0-.45.09 1.25 1.25 0 0 0-.275 2.184 1.25 1.25 0 0 0 1.973-1.014 1.2 1.2 0 0 0-.108-.5 1.26 1.26 0 0 0-1.14-.76"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M13.69 23.94a2.3 2.3 0 0 1-2.27-2.71l.58-2.81a.25.25 0 0 0-.13-.27l-1.234-.635L9.62 19.6a2.07 2.07 0 0 1-1.86 1.17h-4a2.1 2.1 0 1 1 0-4.2H6a.25.25 0 0 0 .23-.16l2.922-6.79H8a.33.33 0 0 0-.21 0l-1.36 1.7a2.14 2.14 0 0 1-3.79-1 2.1 2.1 0 0 1 .45-1.62L5.24 6A2.23 2.23 0 0 1 7 5.22h4.2a4.7 4.7 0 0 1 2 .42L17.76 8l.69-.53a2.4 2.4 0 0 1 2.98 3.76l-1.85 1.52a1.76 1.76 0 0 1-1.95.19L15 11.5l-1 2.48a.26.26 0 0 0 .1.3l2.05 1.3a2.34 2.34 0 0 1 1 2.24L16 22.11a2.29 2.29 0 0 1-2.31 1.83M10.216 8.12H8.07a1.7 1.7 0 0 0-1.4.58l-1.39 1.72a.63.63 0 0 1-.87.12.6.6 0 0 1-.26-.43.62.62 0 0 1 .13-.49L6.4 7a.7.7 0 0 1 .6-.28h4.15a3.1 3.1 0 0 1 1.31.28l5.03 2.59a.75.75 0 0 0 .8-.08l1.06-.81a.9.9 0 0 1 1.12 1.41l-1.86 1.52a.23.23 0 0 1-.27 0l-3.42-1.85a.76.76 0 0 0-1 .38l-1.33 3.26a1.75 1.75 0 0 0 .69 2.12l2 1.3a.9.9 0 0 1 .32.66l-1.06 4.28a.81.81 0 0 1-.8.66.82.82 0 0 1-.62-.28.83.83 0 0 1-.18-.65l.54-2.81a1.74 1.74 0 0 0-.91-1.88l-3.99-2.078L11 9.17a.758.758 0 0 0-.784-1.05m-2.244 8.022L7.6 17A1.73 1.73 0 0 1 6 18.07H3.79a.6.6 0 1 0 0 1.2h4a.59.59 0 0 0 .52-.33l1-2.109z"
      clipRule="evenodd"
    />
  </>
);

export default Running;
